import APIClient from '@/shared/http/clients/api'

const resourceName = 'evento'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}&sort=name,asc`, config)
const GetAllActive = (data = {}, isVisita, config = {}) => APIClient.get(`${APICore}/${resourceName}/?visita=${isVisita ? 1 : 0}&inative=0&sort=name,asc&size=500`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?nome=${document}&page=${index}&size=${limit}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)

const EventRepository = {
  GetAll,
  GetAllPaging,
  GetAllActive,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  ChangeStatus
}

export default EventRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/event.js